import { useState } from "react";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"

const ANSWERS = ['Always', 'Sometimes', 'Never'];

export const InteractiveBlogDetail = ({
    topContent,
    interactiveText,
    items,
    bottomContent,
    contentAboveTextbox,
    textbox,
    contentBelowTextbox,
    className = "",
}) => {
    const [answers, setAnswers] = useState(() =>
        items ? new Array(items.length).fill(null) : []
    );

    const handleSelect = (itemIndex, answer) => {
        setAnswers(prev => {
            const next = [...prev];
            next[itemIndex] = answer;
            return next;
        });
    };

    const counts = ANSWERS.reduce((acc, answer) => {
        acc[answer] = answers.filter(a => a === answer).length;
        return acc;
    }, {});

    const answeredCount = answers.filter(Boolean).length;

    return (
        <section className={`${styles.root} ${className}`}>
            <Container>
                <Row>
                    <Col md={12}>
                        {topContent &&
                            <div className="description" dangerouslySetInnerHTML={{ __html: topContent }} />
                        }
                        {items && items.length > 0 &&
                            <div className={styles.quizWrapper}>
                                {interactiveText &&
                                    <div className={styles.interactive}>
                                        <div dangerouslySetInnerHTML={{ __html: interactiveText }} />
                                    </div>
                                }
                                <ul className={styles.itemList}>
                                    {items.map((item, index) => (
                                        <li key={index} className={styles.quizItem}>
                                            <p className={styles.question}>
                                                {item.question || item.title || item.label || (typeof item === 'string' ? item : '')}
                                            </p>
                                            <div className={styles.answerGroup}>
                                                {ANSWERS.map(answer => (
                                                    <button
                                                        key={answer}
                                                        className={`${styles.answerBtn} ${answers[index] === answer ? styles[`selected${answer}`] : ''}`}
                                                        onClick={() => handleSelect(index, answer)}
                                                        type="button"
                                                    >
                                                        {answer}
                                                    </button>
                                                ))}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {answeredCount > 0 &&
                                    <div className={styles.tally}>
                                        {ANSWERS.map(answer => (
                                            counts[answer] > 0 &&
                                            <p key={answer} className={styles.tallyLine}>
                                                You answered{' '}
                                                <span className={styles[`tally${answer}`]}>&quot;{answer}&quot;</span>
                                                : {counts[answer]} {counts[answer] === 1 ? 'time' : 'times'}
                                            </p>
                                        ))}
                                    </div>
                                }
                            </div>
                        }
                        {bottomContent &&
                            <div className="description pb-5" dangerouslySetInnerHTML={{ __html: bottomContent }} />
                        }
                        {contentAboveTextbox &&
                            <div className="description" dangerouslySetInnerHTML={{ __html: contentAboveTextbox }} />
                        }
                        {textbox &&
                            <div className={styles.textbox}>
                                <div dangerouslySetInnerHTML={{ __html: textbox }} />
                            </div>
                        }
                        {contentBelowTextbox &&
                            <div className="description" dangerouslySetInnerHTML={{ __html: contentBelowTextbox }} />
                        }
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default InteractiveBlogDetail;
